module.exports = __webpack_public_path__ + "static/media/amazon-logo.78e3ca2b.svg";